import { ENVIRONMENT_CONFIG } from '../constants/environmentConfig';
import fetcher from './fetcher';

export const checkOnlineStatus = async () => {
  try {
    const response = await fetcher.get(
      `ping?t=${new Date().getTime()}`,
      undefined,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    if (response?.status === 200) {
      return true;
    }
    return false;
  } catch (err) {
    return false;
  }
};
